import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step-five-content-container" }
const _hoisted_2 = { class: "options-container step-five-container" }
const _hoisted_3 = { class: "container-title" }
const _hoisted_4 = { class: "option-container" }
const _hoisted_5 = {
  class: "title",
  "aria-hidden": "true"
}
const _hoisted_6 = { class: "option-container" }
const _hoisted_7 = {
  class: "title",
  "aria-hidden": "true"
}
const _hoisted_8 = { class: "contacts-container step-five-container" }
const _hoisted_9 = { class: "container-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Switch = _resolveComponent("Switch")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_ContactList = _resolveComponent("ContactList")!
  const _component_ContactSurSiteList = _resolveComponent("ContactSurSiteList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('intervention.stepfive.option.title')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Switch, {
          onToggle: _ctx.toggleRecurrente,
          active: _ctx.recurrente,
          "aria-label": _ctx.$t('intervention.stepfive.option.recurrent')
        }, null, 8, ["onToggle", "active", "aria-label"]),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('intervention.stepfive.option.recurrent')), 1),
        _createVNode(_component_ReglePastille, { cle: "demandeIntervention.interventionRecurrente" })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Switch, {
          onToggle: _ctx.toggleSuivi,
          active: _ctx.suivi,
          "aria-label": _ctx.$t('intervention.stepfive.option.suivi')
        }, null, 8, ["onToggle", "active", "aria-label"]),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('intervention.stepfive.option.suivi')), 1),
        _createVNode(_component_ReglePastille, { cle: "demandeIntervention.suiviDemande" })
      ]),
      (_ctx.suivi)
        ? (_openBlock(), _createBlock(_component_ContactList, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('intervention.stepfive.contacts.title')), 1),
      _createVNode(_component_ContactSurSiteList)
    ])
  ]))
}